import React, { useEffect, useState } from 'react';
import {useFetch, sortByString} from '@utils'
import { Spin, message, Typography } from 'antd';
import {LarpTable } from '@tables';
import { HerbWikiCsv } from './cvs';
const { Text } = Typography;

export default function HerbWiki() {
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [amountShown, setAmountShown] = useState(0);

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = result.filter(_ => {
             return _.item?.name?.toLowerCase().includes(searchValue.toLowerCase())
          || _.id.toString() === searchValue.toString()
        }

        )
        setDataSource(newDataSource);
        setAmountShown(newDataSource.length)
      }, [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue])

      function refresh(id)
      {
          const url = `/api/herb/getwiki`
          doFetch(url)
          .then((response) => onLoaded(response.isSuccess, response.result))
  
          function onLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);
              return;
            }
            setResult([])
            message.error('Could not get herbs');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true
        },
        {
            title: 'Item id',
            key: 'itemId',            
            render: (record) => {
                return record.item?.id
            },
            sorter: (a, b) => a.itemId - b.itemId,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: 'Name',
            key: 'name',            
            render: (record) => {
                return record.item?.name
            },
            sorter: (a, b) => sortByString(a.item?.name, b.item?.name),
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ].filter(_ => !_.hidden)

    function onTableChange(pagination, filters, sorter, extra)
    {
      setAmountShown(extra.currentDataSource.length)
    }

    return (
      <>
        <Text>{amountShown} of {result.length} herbs shown </Text>
        <LarpTable 
          setSearchValue={setSearchValue}
          refresh={refresh}
          dataSource={dataSource}
          columns={columns}
          onTableChange={onTableChange}
          csv={HerbWikiCsv(dataSource)}
        />
      </>
    )
}